import estoreLocations from "../services/estore.locations";
import notification from "../services/notification";
import branches from "../services/branches";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        payment_type: null,
        pagination: {
            currentPage: 1,
            prevPage: 0,
            nextPage: 0,
            maxPage: 0,
            totalPerPage: 1,
            currentFirstItem: 1,
            currentLastItem: 1,
            initialPageCount: 0,
            perPage: 10
        },
        modal: {
            tag_products: {
                status: false
            },
            edit_brand: {
                status: false
            },
            edit_product: {
                status: false
            },
            advance_settings: {
                status: false
            },
            brand_settings: {
                status: false
            },
            branch_settings: {
                status: false
            }
        },
        untaggedProducts: [],
        taggedProducts: [],
        branches: [],
        productInventoryListByBranch: [],
        branchInfo: null,
        brandName: null,
        brandUuid: null,
        param: {
            branchUuid: null,
            page: 1,
            payload: {
                filters: {
                    paired_key: "all",
                    keyword: "",
                    column: "all"
                }
            }
        },
        taggedBrandCategories: [],
        editingFromLocationsPage: false,
        brandBanner: "",
        productCategories: []
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        setModal(state, param) {
            state.modal[param.type].status = param.status;
        },
        setUntaggedProducts(state, untaggedProducts) {
            state.untaggedProducts = untaggedProducts;
        },
        setTaggedProducts(state, taggedProducts) {
            state.taggedProducts = taggedProducts;
        },
        addSelectedProductsToTaggedProducts(state, selectedProducts) {
            selectedProducts.forEach(selectedProduct => {
                state.taggedProducts.push(selectedProduct);
            });
            state.taggedProducts = state.taggedProducts.filter(
                (taggedProduct, index, self) =>
                    index === self.findIndex(t => t.uuid === taggedProduct.uuid)
            );
            let taggedProductsUuids = state.taggedProducts.map(a => a.uuid);
            state.untaggedProducts = state.untaggedProducts.filter(function(
                item
            ) {
                return taggedProductsUuids.indexOf(item.uuid) === -1;
            });
        },
        removeTaggedProductsForRemovalFromTaggedProducts(
            state,
            taggedProductsForRemoval
        ) {
            taggedProductsForRemoval.forEach(taggedProductForRemoval => {
                state.untaggedProducts.push(taggedProductForRemoval);
            });
            state.untaggedProducts = state.untaggedProducts.filter(
                (untaggedProduct, index, self) =>
                    index ===
                    self.findIndex(t => t.uuid === untaggedProduct.uuid)
            );
            let untaggedProductsUuids = state.untaggedProducts.map(a => a.uuid);
            state.taggedProducts = state.taggedProducts.filter(function(item) {
                return untaggedProductsUuids.indexOf(item.uuid) === -1;
            });
        },
        removeAllTaggedProductsFromTaggedProducts(
            state,
            taggedProductsForRemoval
        ) {
            taggedProductsForRemoval.forEach(taggedProductForRemoval => {
                state.untaggedProducts.push(taggedProductForRemoval);
            });
            state.taggedProducts = [];
        },
        setBranches(state, branches) {
            state.branches = branches;
        },
        setBrandName(state, brandName) {
            state.brandName = brandName;
        },
        setBrandUuid(state, brandUuid) {
            state.brandUuid = brandUuid;
        },
        setProductInventoryListByBranch(state, productInventoryListByBranch) {
            state.productInventoryListByBranch = productInventoryListByBranch;
        },
        setBranchInfo(state, branchInfo) {
            state.branchInfo = branchInfo;
        },
        setPagination(state, pagination) {
            state.pagination.totalPerPage = pagination.list.length;
            state.pagination.maxPage =
                state.pagination.totalPerPage > 0 ? pagination.max_page : 0;
            state.pagination.prevPage = pagination.prev_page;
            state.pagination.nextPage = pagination.next_page;
            state.pagination.currentPage = state.pagination.prevPage + 1;
            state.pagination.currentFirstItem =
                state.pagination.totalPerPage > 0
                    ? state.pagination.initialPageCount *
                          state.pagination.prevPage +
                      1
                    : 0;
            state.pagination.currentLastItem =
                state.pagination.currentFirstItem > 0
                    ? state.pagination.currentFirstItem +
                      state.pagination.totalPerPage -
                      1
                    : 0;
        },
        setParam(state, param) {
            state.param = param;
        },
        setPaymentType(state, type) {
            state.payment_type = type;
        },
        setTaggedBrandCategories(state, taggedBrandCategories) {
            state.taggedBrandCategories = taggedBrandCategories;
        },
        setEditingFromLocationsPage(state, boolean) {
            state.editingFromLocationsPage = boolean;
        },
        updateValues(state, taggedBrandCategories) {
            state.taggedBrandCategories = taggedBrandCategories;
        },
        brandBanner(state, brandBanner) {
            state.brandBanner = brandBanner;
        },
        productCategories(state, productCategories) {
            state.productCategories = productCategories;
        }
    },
    actions: {
        async getUntaggedProducts({ commit }, param) {
            commit("loading", true);
            try {
                let response = await estoreLocations.getUntaggedProducts(param);
                commit("setUntaggedProducts", response.list);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getTaggedProducts({ commit }, param) {
            commit("loading", true);
            try {
                let response = await estoreLocations.getTaggedProducts(param);
                commit("setTaggedProducts", response.list);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getBranchList({ commit }, param) {
            commit("loading", true);
            try {
                let response = await estoreLocations.getBranchList(param);
                commit("setBrandUuid", param.uuid);
                commit("setBranches", response.map(branch => branch.uuid));
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async addStoreBrandProducts({ commit }, param) {
            commit("loading", true);
            try {
                // let paramTag = {
                //     for_add: param.for_add,
                //     branches: param.branches,
                //     brand_uuid: param.brand_uuid
                // }
                // let paramUntag = {
                //     for_delete: param.for_delete,
                //     branches: param.branches,
                //     brand_uuid: param.brand_uuid
                // }
                let response = await estoreLocations.addStoreBrandProducts(
                    param
                );

                commit("loading", false);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, looks like something went wrong.");
            }
        },
        async getListProductInventoryByBranch({ commit }, param) {
            commit("loading", true);
            try {
                let response = await estoreLocations.getListProductInventoryByBranch(
                    param
                );
                commit("setBranchInfo", response.branch_info);
                commit("setProductInventoryListByBranch", response.list);
                commit("setPagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async saveBrandCategories({ commit }, param) {
            commit("loading", true);
            try {
                let response = await estoreLocations.saveBrandCategories(param);
                commit("loading", false);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, looks like something went wrong.");
            }
        },
        async getBrandCategories({ commit }, param) {
            commit("loading", true);
            try {
                let response = await estoreLocations.getBrandCategories(param);
                commit(
                    "setTaggedBrandCategories",
                    response.item.map(obj => {
                        let taggedBrandCat = {};
                        taggedBrandCat["id"] = obj.uuid;
                        taggedBrandCat["name"] = obj.name;
                        return taggedBrandCat;
                    })
                );
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async saveBrandBannerImage({ commit }, param) {
            commit("loading", true);
            try {
                let response = await estoreLocations.saveBrandBannerImage(
                    param
                );
                commit("loading", false);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, looks like something went wrong.");
            }
        },
        async getBrandBannerImage({ commit }, param) {
            commit("loading", true);
            try {
                let response = await estoreLocations.getBrandBannerImage(param);
                commit("brandBanner", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        updateValues({ commit }, taggedBrandCategories) {
            commit("updateValues", taggedBrandCategories);
        },
        async saveBrandProductCategory({ commit }, param) {
            commit("errors", null);
            commit("loading");
            try {
                let response = await estoreLocations.saveBrandProductCategory(
                    param
                );
                console.log(response);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async getBrandProductCategory({ commit }, uuid) {
            commit("errors", null);
            commit("loading");
            try {
                let response = await estoreLocations.getBrandProductCategory(
                    uuid
                );
                // console.log(response);
                commit("productCategories", response);
                commit("loading", false);
            } catch (errors) {
                // notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        async updateBranchPickupStatus({ commit }, param) {
            commit("loading", true);
            try {
                let response = await estoreLocations.updateBranchPickupStatus(
                    param
                );
                commit("loading", false);
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
                notification.warning("Oops, looks like something went wrong.");
            }
        }
    }
};
